const isAmountNull = (value) => {
    if (
        value === '' ||
        value === 0 ||
        value === '0'||
        value === null ||
        value === '0.00'||
        value === '0.0'||
        value === undefined) {
        return true
    } else {
        return false
    }
}

export default isAmountNull